import * as Yup                 from    'yup';
import {
        PlaceOfSupply,
        GSTTreatment        }   from    '../../../../../common/common.model';
import { verifyGST } from '../../../../../common/common.service';


export default Yup.object({
    firstName                   :   Yup.string()
                                    .required('First name is required!')
                                    .test('alphabets', 'First name must only contain alphabets', (value: any) => {
                                        return /^[A-Za-z]+$/.test(value);
                                    }),

    lastName                    :   Yup.string()
                                    .required('Last name is required!')
                                    .test('alphabets', 'Last name must only contain alphabets', (value: any) => {
                                        return /^[A-Za-z]+$/.test(value);
                                    }),

    email                       :   Yup.string()
                                    .email('Email is not valid!'),

    companyName                 :   Yup.string()
                                    .required('Company name is required!'),

    phone                       :   Yup.string()
                                    .required('Phone number is required!')
                                    .min(10, 'Phone number is not valid!')
                                    .max(12, 'Phone number is not valid!')
                                    .test('numbers', 'Phone number must be numbers', (value: any) => {
                                        return /^[0-9]+$/.test(value);
                                    }),

    openingBalance              :   Yup.number()
                                    .required('Opening Balance is required!')
                                    .typeError('Opening balance is not valid!'),

    address                     :   Yup.string()
                                    .required('Address is required!')
                                    .min(6, 'Address should be atleast 6 characters!'),

    city                        :   Yup.string()
                                    .required('City is required!')
                                    .min(2, 'City is not valid!'),

    state                       :   Yup.string()
                                    .required('State is required!')
                                    .min(2, 'State is not valid!'),

    zipcode                     :   Yup.string()
                                    .required('Zipcode is required!')
                                    .min(6, 'Zipcode is not valid!')
                                    .max(6, 'Zipcode is not valid!'),

    gstin                       :   Yup.string()
                                    .when("gstTreatment", {
                                        is: (value) => [GSTTreatment.Registered].includes(value),
                                        then: Yup.string().required('GSTIN is required!')
                                                            .test('gstin', 'GSTIN is not valid!', function(value: any) {
                                                                return new Promise((resolve, reject) => {
                                                                    if(value) {
                                                                        if(value.length === 15) {
                                                                            verifyGST(value).then((data: any) => resolve(data)).catch(_ => resolve(false))
                                                                        } else {
                                                                            resolve(false);
                                                                        }
                                                                    } else {
                                                                        resolve(true);
                                                                    }
                                                                })
                                                            }),
                                    }),
    gstTreatment                :   Yup.string()
                                    .required('GST Treatment is required!')
                                    .oneOf([GSTTreatment.Registered, GSTTreatment.Unregistered, GSTTreatment.None], 'GST Treatment is not valid!'),

    placeOfSupply               :   Yup.string()
                                    .required('Place of supply is required!')
                                    .oneOf([PlaceOfSupply.TN, PlaceOfSupply.KL, PlaceOfSupply.KN], 'Place of supply is not valid!')
})